export const ORDERED_BUCKETS = ['seated', 'rsvp'];
export const FACET_ELEMENTS = {
  seated: { key: 'seated', name: 'Seated' },
  notSeated: { key: 'notSeated', name: 'Not Seated' },
  attending: { key: 'attending', name: 'Attending' },
  undecided: { key: 'undecided', name: 'No Response' },
  declined: { key: 'declined', name: 'Not Attending' },
};
export const FACETS_SHAPE = {
  seated: {
    key: 'seated',
    label: 'By Seated Status',
    elements: ['seated', 'notSeated'],
  },
  rsvp: {
    key: 'rsvp',
    label: 'By RSVP Status',
    elements: ['attending', 'undecided', 'declined'],
  },
  // invited: {
  //   key: 'invited',
  //   label: 'By Invited Status',
  //   elements: ['invited', 'notInvited'],
  // },
};



// WEBPACK FOOTER //
// ./src/constants/seatingChartConstants.js